export const about = {
  title: 'About',
  detailedTitle: 'Decentralized Payment Solution built on Tezos blockchain',
  build: 'build',
  poweredBy: 'Powered by',
  tzKt: 'TzKT',
  api: 'API'
};
